import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './StandaloneIcon.css';

const StandaloneIcon = ({
  icon,
  className,
  hasNoBackground,
  disabled = false,
  notAllowed = false,
  ...props
}) => (
  <button
    type="button"
    {...props}
    className={classNames(
      'standalone-icon',
      className, disabled && "disabled", notAllowed && "not-allowed"
    )}
  >
    <div className={classNames({
      'standalone-icon__bg': !hasNoBackground,
    })}
    >
      <i className="material-icons">{icon}</i>
    </div>
  </button>
);

StandaloneIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  hasNoBackground: PropTypes.bool,
};

export default StandaloneIcon;



// WEBPACK FOOTER //
// ./src/components/StandaloneIcon/StandaloneIcon.jsx